import { WsErrorsEnum } from '../../../chatSocket/constants/webSocketErrors.constants';

export enum CustomExceptions {
  NON_RECOGNIZED_EXCEPTION = 'NON_RECOGNIZED_EXCEPTION',
}

export type RecognizedExceptions = WsErrorsEnum | CustomExceptions;
